// extracted by mini-css-extract-plugin
export default {"Componenterror":"Component500_Componenterror__2EezM","wrapper":"Component500_wrapper__gNzbR","error":"Component500_error__Ymkm-","description":"Component500_description__eiD5c"};